import LoadingIcon from "../common/LoadingIcon";
import React from "react";
import Modal from "../common/Modal";

export default function LoadingOverlay({
  loading,
  text,
}: {
  loading: boolean;
  text: string;
}) {
  return (
    <Modal isOpen={loading}>
      <LoadingIcon text={text} />
    </Modal>
  );
}
